import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SpouseInformationEnum } from './spouse-information.enum';

@Component({
  selector: 'app-spouse-information-radio-buttons',
  templateUrl: './spouse-information-radio-buttons.component.html',
  styleUrls: ['./spouse-information-radio-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class SpouseInformationRadioButtonsComponent implements OnInit {
  @Input() spouseInfo: SpouseInformationEnum = SpouseInformationEnum.Current;
  @Output() spouseInfoChange = new EventEmitter<SpouseInformationEnum>();

  public formGroup!: FormGroup;

  public ngOnInit(): void {
    this.formGroup = new FormGroup({ spouse: new FormControl(this.spouseInfo) });
  }

  protected readonly SpouseInformationEnum = SpouseInformationEnum;
}
